<template>
  <div class="original-exam">
    <template>
      <!-- 教科選択 -->
      <v-section-panel useBreak>
        <template v-slot:title> 種別 <font color="#ff4a3d" size="2">❇︎</font></template>
        <template v-slot:content>
          <v-choice-categories :listType="listType"/>
        </template>
      </v-section-panel>

      <!-- 応用問題を選択した場合、種別の選択を表示  -->
      <v-question-type-select-options useBreak showHanigo class="" v-if="ouyouSelected"/>

      <!-- 単語/連語選択 -->
      <v-section-panel useBreak v-if="(reibunSelected || katsuyoSelected) && !themeSelected">
        <template v-slot:title> 単語/連語選択（※複数選択可） <font color="#ff4a3d" size="2">❇︎</font></template>
        <template v-slot:content>
          <v-choice-word />
        </template>
      </v-section-panel>

      <!-- 和英選択 -->
      <v-section-panel useBreak v-if="reibunSelected">
        <template v-slot:title> 英/和選択（※複数選択可） <font color="#ff4a3d" size="2">❇︎</font></template>
        <template v-slot:content>
          <v-choice-eiwa />
        </template>
      </v-section-panel>

      <!-- 品詞の限定 -->
      <v-question-hinshi-options useBreak class="" v-if="reibunSelected && !themeSelected"/>

      <!-- 英和、和英いずれか選択済の場合、範囲・問題数選択を表示  -->
      <v-question-range-options useBreak isGetthrough class="" v-if="categorySelected"/>

    </template>
  </div>
</template>

<script>
import VSectionPanel from '@/components/molecules/SectionPanel'
import VChoiceCategories from '@/components/molecules/ChoiceCategories'
import VChoiceEiwa from '@/components/molecules/ChoiceEiwa'
import VQuestionTypeSelectOptions from '@/components/organizms/QuestionTypeSelectOptions'
import VQuestionRangeOptions from '@/components/organizms/QuestionRangeOptions'
import VChoiceWord from '@/components/molecules/ChoiceWord'
import VQuestionHinshiOptions from '@/components/organizms/QuestionHinshiOptions'

export default {
  components: {
    VSectionPanel,
    VQuestionTypeSelectOptions,
    VChoiceCategories,
    VChoiceEiwa,
    VQuestionRangeOptions,
    VChoiceWord,
    VQuestionHinshiOptions,
  },

  data: () => ({
    listType: 'getthrough',
  }),

  computed: {
    categorySelected() {
      let result = false
      if(this.$store.state.conditions.selectedCategory > 0) {
        if(this.$store.state.conditions.selectedCategory === 2) {
          //応用問題の場合は、例文・活用・反意語のいずれかにチェックがついている場合のみtrue
          if((this.$store.state.conditions.checkedArr['reibun'].length > 0 && this.$store.state.conditions.checkedArr['target'].length!==0 && this.$store.state.conditions.checkedArr['eiwa'].length!==0)
            || this.$store.state.conditions.checkedArr['katsuyo'].length > 0
            || this.$store.state.conditions.checkedArr['hanigo'].length > 0) {
            result = true
          }

        } else if(this.$store.state.conditions.selectedCategory === 3) {
          //テーマ別の場合（単語は固定で指定しているので、英和選択済みの場合true）
          if(this.$store.state.conditions.checkedArr['eiwa'].length===0) result = false
          else result = true

        } else if(this.$store.state.conditions.selectedCategory === 1) {
          //見出しの場合(単語・連語が選択済み かつ 英和選択済みの場合のみtrue)
          if(this.$store.state.conditions.checkedArr['target'].length===0 || this.$store.state.conditions.checkedArr['eiwa'].length===0) result = false
          else result = true
        }
      }
      return result
    },
    midashiSelected() {
      return this.$store.state.conditions.selectedCategory === 1
    },
    ouyouSelected() {
      return this.$store.state.conditions.selectedCategory === 2
    },
    themeSelected() {
      if (this.$store.state.conditions.selectedCategory===3) {
        // テーマ別を選択時は「単語/連語」の選択がないので「単語」を設定しておく
        this.$store.commit('conditions/resetCheckListTarget', {})
        this.$store.commit('conditions/setCheckList', {
            listName: 'target',
            value: [1]
        })
      }
      return this.$store.state.conditions.selectedCategory === 3
    },
    reibunSelected() {
      let result = false
      if(this.$store.state.conditions.selectedCategory > 0) {
        if(this.$store.state.conditions.selectedCategory === 2) {
          //応用問題の場合は、例文にチェックがついている場合のみtrue
          if(this.$store.state.conditions.checkedArr['reibun'].length > 0) {
            result = true
          }
        } else {
          //見出し・テーマ別の場合はtrue
          result = true
        }
      }
      return result
    },
    katsuyoSelected() {
      let result = false
      if(this.$store.state.conditions.selectedCategory > 0) {
        if(this.$store.state.conditions.selectedCategory === 2) {
          if(this.$store.state.conditions.checkedArr['hanigo'].length > 0) {
            result = true
          }
        }
      }
      return result
    }
  },

  methods: {
    questionCreate() {
    }
  }
}
</script>

<style lang="stylus" scoped>
.choice-material__attention
  color #747474
</style>
